import React from "react";
import { Box, Grid } from "@mui/material";
import { BLOCKS, MARKS } from "@contentful/rich-text-types";
import SocialMediaIcons from "../../molecules/social-media-icons/socialMediaIcons";
import { useFooterData } from "./query";
import FooterColumnData from "../../atoms/footer-column/FooterColumnData";
import FooterRegulation from "../../atoms/footer-regulation/FooterRegulation";
import rawToReact from "../../../utils/rawToReact";

import "./footer.scss";

export interface CategoryContent {
    nombreCategoria: string;
    referenciaSubcategorias: SubCategoryContent[];
}

interface SubCategoryContent {
    titulo: string;
    slug: null | string;
    link: null | string;
    nombreSubcategoria: string;
    tipoCampo: null | string;
    appStore: null;
    playStore: null;
}

const options = {
    renderMark: {
        [MARKS.ITALIC]: (text) => (
            <span className={`o_footer__version`}>{text}</span>
        ),
        [MARKS.BOLD]: (text) => <div className={`o_footer__title`}>{text}</div>,
        [MARKS.UNDERLINE]: (text) => (
            <div className={`o_footer__magenta`}>{text}</div>
        ),
    },
    renderNode: {
        [BLOCKS.EMBEDDED_ASSET]: (node) => (
            <img
                className={`o_footer__logo`}
                src={node?.data?.target?.fields?.file["en-US"]?.url}
                alt={
                    node?.data?.target?.fields?.file["en-US"].fileName.split(
                        "."
                    )[0]
                }
            />
        ),
    },
};

const FooterNew = () => {
    const queryData = useFooterData();

    const allCategoriesColumn: CategoryContent[] =
        queryData?.allContentfulFooter?.nodes?.[0]?.categorias || [];

    const [socialMediaCategory, ...categoriesColumn] = allCategoriesColumn;

    const footerContentTwoData =
        queryData?.allContentfulFooterSeccion2?.nodes?.[0];

    return (
        <Box component="footer" id="footer" className={`o_footer`}>
            <div className={`o_footer__container`}>
                <Grid container item lg={12} md={10} className={`o_footer__grid`}>
                    <Box className={`o_footer__siguenos`}>
                        <SocialMediaIcons content={socialMediaCategory} />
                    </Box>
                    <Box component={"section"} className={`o_footer__cols`}>
                        {categoriesColumn.map((col, colIdx) => {
                            return (
                                <FooterColumnData
                                    key={`footer-column-${col.nombreCategoria}-${colIdx}`}
                                    columnData={col}
                                />
                            );
                        })}
                    </Box>
                </Grid>
            </div>
            <FooterRegulation
                logoServiceEmpleo={footerContentTwoData?.logoServicioDeEmpleo}
                logoComfama={footerContentTwoData?.logoComfama}
                logoAsojacas={footerContentTwoData?.logoAsojacas}
                logoRedPactoGlobal={footerContentTwoData?.logoRedPactoGlobal}
                logoSupersubsitio={
                    footerContentTwoData?.logoVigiladosHorizontal
                }
                description={rawToReact(
                    footerContentTwoData?.descripcion.raw,
                    options
                )}
            />
            {footerContentTwoData?.Copyright && (
                <Box className={`o_footer__copyright`}>
                    {footerContentTwoData?.Copyright}
                </Box>
            )}
        </Box>
    );
};

export default FooterNew;
